import React from "react";
export var Loading = function () {
    return React.createElement(React.Fragment, null);
};
